import i18n from 'i18next';
import EnvironmentDetection from '../lib/EnvironmentDetection';

export const i18nOptions = (lng = 'de', resources = {}) =>
  (({
    lng,
    debug: EnvironmentDetection.isBrowser && process.env.NODE_ENV === 'development',

    // we init resources with useSSR from react-i18next
    // empty object so i18next knows we did not forget a backend connector
    resources,

    initImmediate: false,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    react: {
      useSuspense: false,
      bindI18nStore: false,
      // react-i18next v.15.0.0 introduced a change where bindI18n is evaluated like this:
      // options.bindI18n?.indexOf('languageChanging')
      // So we either have to set this option to '' or remove it altogether. (null will lead to tsc errors)
      bindI18n: '',
      transSupportBasicHtmlNodes: false,
      transKeepBasicHtmlNodesFor: [],
    },
  }) as const);

export default i18n;
